import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {serialize} from 'class-transformer';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';
import {Content} from 'shared/models/contents/content';
import {IContentsDetailsRepository} from './contents-details.repository.interface';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import { Dialog } from 'shared/classes/dialog';

@Injectable()
export class ContentsDetailsHttpRepository implements IContentsDetailsRepository {

  constructor(private http: Http) { }

  public getContent(id: string): Observable<Content> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.contents}/${id}`, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public getContents(): Observable<Array<Content>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(environment.contents, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.targetGroups}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getDialogs(): Observable<Array<Dialog>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});
    return this.http.get(environment.dialogs, options)
      .map((response: Response) => {
        return response.json();
      })
      .map((rawDialogs: Array<Dialog>) => {
        return this.mapToDialogs(rawDialogs);
      });
  }

  private mapToDialogs(rawDialogs: Array<Dialog>): Array<Dialog> {
    return rawDialogs.map((rawDialog) => {
      return Dialog.create(rawDialog);
    });
  }

  public saveContent(content: Content): Observable<Content> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(content);

    return this.http.post(environment.contents, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }

  public updateContent(content: Content): Observable<Content> {
    const headers: Headers = new Headers({
      'Content-Type': 'application/json',
    });

    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
      headers: headers,
    });
    const body: string = serialize(content);

    return this.http.put(`${environment.contents}/${content._id}`, body, options)
      .map((res: Response) => {
        return res.json();
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/contents/contents-details/repositories/contents-details.repository.http.ts